<template>
  <div class="reimbursement-type preliminary-type">
    <div class="reimbursement-type-container">
      <div class="left-container">
        <type-tree
          :list="list"
          :listId="id"
          :type="type"
          @del="del"
          @delPreliminaryType="delPreliminaryType"
          @selectTreeNodeList="selectTreeNodeList"
          @openPreliminaryAddBill="openPreliminaryAddBill"
          @openPreliminaryModType="openPreliminaryModType"
          @openPreliminaryAddType="openPreliminaryAddType"
        />
      </div>
      <div class="container" v-if="id">
        <div class="phone">
          <div class="inset-phone" v-if="id">
            <div class="title">
              <div class="title-name">
                <p v-if="isMod">{{ title }}</p>
                <el-input ref="customerInput" v-if="!isMod && officialType == '' " class="gray white" v-model="title" autofocus @blur="blur"></el-input>
              </div>
              <img src="../../../../assets/mod.png" @click="modTitle">
            </div>
            <div v-if="officialType == 'WithoutOfficialCard'" class="phone-content">
              <div class="row">
                <div class="sub-title">
                  姓名
                </div>
                <div class="phone-content">系统自动获取</div>
              </div>
              <div class="row">
                <div class="sub-title">
                  单位
                </div>
                <div class="phone-content">系统自动获取</div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>日期</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请选择</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>金额</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请输入</span>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>未使用原因</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请输入原因</span>
                </div>
              </div>
            </div>
            <div v-if="officialType == 'BizTripTrial'" class="phone-content">
              <div class="row">
                <div class="sub-title">
                  <span>类型</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请选择</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  姓名
                </div>
                <div class="phone-content">系统自动获取</div>
              </div>
              <div class="row">
                <div class="sub-title">
                  职、级别
                </div>
                <div class="phone-content">系统自动获取</div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>到达地点</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请选择</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="date">
                <div class="row">
                  <div class="sub-title">
                    <span>出差日期（开始）</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请选择</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="row">
                  <div class="sub-title">
                    <span>出差日期（结束）</span>
                    <span class="star">*</span>
                  </div>
                  <div class="phone-content">
                    <span>请选择</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>出差天数</span>
                </div>
                <div class="phone-content">
                  <span>自动计算天数</span>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>出差事由</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请输入</span>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>出差方式</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请输入</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="peer">
                <div class="peer-row">
                  <div class="row">
                    <div class="sub-title">
                      <span>姓名</span>
                    </div>
                    <div class="phone-content">
                      <span>请输入</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="sub-title">
                      <span>单位</span>
                    </div>
                    <div class="phone-content">
                      <span>请输入</span>
                    </div>
                  </div>
                </div>
                <div class="peer-row">
                  <div class="row">
                    <div class="sub-title">
                      <span>职级</span>
                      <span class="star">*</span>
                    </div>
                    <div class="phone-content">
                      <span>请输入</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="sub-title">
                      <span>随员</span>
                      <span class="star">*</span>
                    </div>
                    <div class="peer-phone-content">
                      <el-radio v-model="radio" :label="1">是</el-radio>
                      <el-radio v-model="radio" :label="2">否</el-radio>
                    </div>
                  </div>
                </div>
                <div class="peer-row">
                  <div class="row">
                    <div class="sub-title">
                      备注
                    </div>
                    <div class="phone-content">请输入明细描述</div>
                  </div>
                </div>
                <div class="peer-row">
                  <div class="peer-text">+增加同行人员</div>
                </div>
              </div>
              <div class="row">
                <div class="sub-title">
                  特殊情况说明
                </div>
                <div class="phone-content">请输入费用明细描述</div>
              </div>
              <div class="row">
                <div class="sub-title">
                  <span>是否上会</span>
                  <span class="star">*</span>
                </div>
                <div class="phone-content">
                  <span>请选择</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
            
            <div class="phone-content" v-if="officialType == ''">
              <div
                class="component-container"
                v-for="(item, index) in allComponent"
                :key="index"
              >
                <component
                  :is="item.htmlContent"
                  :name="item.name"
                  :placeholder="item.placeholder"
                  :required="item.required"
                  :isSelect="item.isSelect"
                  :startTime="item.startTime"
                  :endTime="item.endTime"
                  :durationTime="item.durationTime"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container" v-if="id">
        <div class="tip">
          <p>
            1.此表单只生效与单预审批类型，如果需要其他审批类型的表单，请选择其他审批类型新建表单。
          </p>
          <p>2.需管理此表单字段控件，请点击下方 “编辑”按钮。</p>
          <div>
            <span>3.审批流程：</span>
            <span class="not-set" >{{ approvalRelateFlag == 1?'已设置':'未设置'}}</span>
          </div>
        </div>
        <el-button
        v-if="
          OPERATION_LIST.findIndex(
            (item) => item === OPERATIONS_BTNS.roleUpdatePreApprovalForm
          ) !== -1
        "
        class="btn-blue" type="primary" @click="mod">编辑</el-button>
      </div>
      
      <div v-if="!id" class="nothing">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>

    <!-- 重命名, 新增单据 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        class="demo-ruleForm"
      >
        <el-form-item label="分类名称" prop="name" v-if="dialogTitle === '重命名' || dialogTitle === '新增分类'">
          <el-input class="gray white" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="单据名称" prop="billName" v-if="dialogTitle !== '重命名' && dialogTitle !== '新增分类'">
          <el-input class="gray white" v-model="form.billName"></el-input>
        </el-form-item>
        <el-form-item label="上级分类" prop="categoryParent" v-if="dialogTitle !== '重命名' && dialogTitle !== '新增分类'">
          <el-input class="gray white" disabled v-model="form.categoryParent"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import TypeTree from '@/components/type-tree.vue'
import BillAdmin from "@/models/bill-admin.js";
import { mapId5 } from "@/common/js/utils.js";
import { formControlMixins } from "@/common/mixins/form/form-control.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [formControlMixins, operationMixins],
  components: {
    TypeTree
  },

  data() {
    return {
      list: [],
      id: 0,
      type: 2,
      title: '',
      isMod: true,
      approvalRelateFlag: 2,
      allComponent: [],
      secondTypeId: '',
      depId: '',
      billType: '',
      
      /* -----------------   以下是重命名, 新增单据字段   ----------- */
      dialogVisible: false,
      form: {
        billName: '',
        name: '',
        categoryParent: ''
      },
      rules: {
        billName: [{ required: true, message: "请输入单据名称", trigger: "blur" }],
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      dialogTitle: '',
      radio: 2
    }
  },

  created() {
    config()
    this.initPreliminaryTypeList()
  },

  methods: {
    initPreliminaryTypeList() {
      let queryStr = ''
      BillAdmin.getPreliminaryTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = this.mapChild(res.result);
          this.list = mapId5(arr, this.id)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取自定义预审批单详情 */
    _getPreliminaryDetails() {
      let id = this.id
      BillAdmin.getPreliminaryDetails(id).then(res => {
        if (res.success) {
          this.title = res.result.name
          this.depId = res.result.deptId,
          this.billType = res.result.type,
          this.approvalRelateFlag = res.result.approvalRelateFlag
          let { controlList, translateList } = res.result
          let arr = ["text", "textarea", "numText", "amountText", "radio", "date", "addressSelect"]
          let arr2 = ["dateRange"]
          let arr3 = ["img", "enclosure"]
          let arr4 = ["agentText", "levelText"]
          function filterFnc(v) {
            let valueObj = translateList.filter(item => {
              return item.key == v 
            })
            return valueObj.length > 0? valueObj[0].value: ''
          }
          let allComponent = []
          controlList.map(i => {
            let obj = {}
            if (arr.indexOf(i.type) !== -1) {
              obj.htmlContent = 'TextComponent'
              obj.name = filterFnc(i.name)
              obj.placeholder = filterFnc(i.placeholder)
              obj.value = JSON.parse(i.value)
            }
            if (arr2.indexOf(i.type) !== -1) {
              obj.htmlContent = 'DateRange'
              obj.name = i.name
              obj.value = JSON.parse(i.value)
              obj.placeholder = filterFnc(obj.value.start.placeholder)
              obj.startTime = filterFnc(obj.value.start.name)
              obj.endTime = filterFnc(obj.value.end.name)
              obj.durationTime = filterFnc(obj.value.days.name)
            }
            if (arr3.indexOf(i.type) !== -1) {
              obj.htmlContent = 'UploadComponent'
              obj.name = filterFnc(i.name)
              obj.value = JSON.parse(i.value)
            }
            if (arr4.indexOf(i.type) !== -1) {
              obj.htmlContent = 'TextComponent'
              obj.name = filterFnc(i.name)
              obj.value = JSON.parse(i.value)
            }
            obj.sort = i.sort
            obj.required = i.isRequst
            obj.isSelect = i.isRequst
            allComponent.push(obj)
          })
          this.allComponent = allComponent
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取固定预审批单详情 */
    _getFixedPreliminaryDetails() {
      let id = this.id
      BillAdmin.getFixedPreliminaryDetails(id).then(res => {
        if (res.success) {
          this.title = res.result.name
          this.approvalRelateFlag = res.result.approvalRelateFlag
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    
    mapChild(child) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        obj.id = value.id;
        obj.label = value.name;
        obj.level = value.level;
        obj.officialType = value.systemPreset;
        obj.identification = value.identification
        if (value.subList && value.subList.length > 0 && value.level == 1) {
          obj.children = this.mapChild(value.subList);
        } else {
          if (value.preApprovalFormList && value.preApprovalFormList.length > 0) {
            obj.children = this.mapChild(value.preApprovalFormList);
          } else {
            obj.children = [];
          }
        }
        arr.push(obj);
      });
      return arr;
    },

    selectTreeNodeList(v) {
      if (v.level > 2) {
        this.title = v.label
        this.officialType = v.identification
        this.id = v.id
        if (v.identification == '') {
          this._getPreliminaryDetails()
        } else {
          this._getFixedPreliminaryDetails()
        }
      } else {
        this.title = ''
        this.id = 0
      }
      if (v.identification == ''&&v.level == 2) {
        this.title = ''
      }
    },

    /* 删除模板 */
    del(v) {
      if (v.children && v.children.length > 0) {
        this.$alert('请先删除所有子单据再进行删除分类操作', '确认删除分类', {
          confirmButtonText: '好的',
          confirmButtonClass: 'btn-gray'
        })
      } else {
        this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          let data = {
            id: v.id
          }
          BillAdmin.postDelPreliminary(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功'
              });
              this.initPreliminaryTypeList()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        });
      }
    },

    /* 删除类型 */
    delPreliminaryType(v) {
      if (v.children && v.children.length > 0) {
        this.$alert('请先删除所有子单据再进行删除分类操作', '确认删除分类', {
          confirmButtonText: '好的',
          confirmButtonClass: 'btn-gray'
        })
      } else {
        this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonClass: 'btn-red',
          cancelButtonClass: 'btn-gray'
        }).then(() => {
          let data = {
            id: v.id
          }
          BillAdmin.postDelPreliminaryType(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '删除成功'
              });
              this.initPreliminaryTypeList()
            } else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        });
      }
    },

    modTitle() {
      this.isMod = false
      this.$nextTick(function () {
        this.$refs.customerInput.$el.querySelector('input').focus();
      });
    },
    
    blur() {
      this.isMod = true
      this._postPreliminaryBillName()
    },

    mod() {
      this.$router.push({
        path: '/formIndex/formControl',
        query: {
          typeId: this.id,
          title: this.title,
          officialType: this.officialType,
        }
      })
    },

    // toApproval() {
    //   if (this.approvalRelateFlag == 1) {
    //     this.$router.push({
    //       path: '/fire/approvalIndex/approvalPreliminary',
    //       query: {
    //         formId: this.id,
    //         depId: this.depId,
    //         billType: this.billType,
    //         officialType: this.officialType
    //       }
    //     })
    //   } else {
    //     this.$router.push({
    //       path: '/fire/approvalIndex/approvalPreliminary'
    //     })
    //   }
    // },

    _postPreliminaryBillName() {
      let data = {
        name: this.title,
        id: this.id
      }
      BillAdmin.postPreliminaryBillName(data).then(res => {
        if (res.success) {
          this.initPreliminaryTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* -----------------   以下是重命名, 新增单据方法   ----------- */
    handleClose() {
      this.dialogVisible = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dialogTitle == '新增分类') {
            let data = {
              parentId: this.id,
              name: this.form.name
            }
            BillAdmin.postAddPreliminaryType(data).then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '新增分类成功'
                });
                this.initPreliminaryTypeList()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          } else if (this.dialogTitle == '重命名') {
            let data = {
              id: this.id,
              name: this.form.name
            }
            BillAdmin.postModPreliminaryType(data).then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '重命名成功'
                });
                this.initPreliminaryTypeList()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          }else if (this.dialogTitle == '添加单据') {
            let data = {
              type: this.id,
              name: this.form.billName
            }
            BillAdmin.postAddPreliminaryBillName(data).then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '添加单据成功'
                });
                this.initPreliminaryTypeList()
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
            })
          }
          this.handleClose()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /* 重命名 */
    openPreliminaryModType(v) {
      this.dialogTitle = '重命名'
      this.dialogVisible = true
      this.form.name = v.label
      this.id = v.id
    },

    /* 添加单据 */
    openPreliminaryAddBill(v) {
      this.dialogTitle = '添加单据'
      this.dialogVisible = true
      this.form.categoryParent = v.label
      this.id = v.id
    },

    /* 新增分类 */
    openPreliminaryAddType(v) {
      this.dialogTitle = '新增分类'
      this.dialogVisible = true
      this.form.name = ''
      this.id = v.id
    }
  }
}
</script>

<style lang='scss'>
.preliminary-type {
  .right-container {
    .tip {
      height: 158px;
      line-height: 22px;
      .not-set {
        color: $color-Crimson;
      }
    }
    .el-button {
      @include flex-center;
    }
  }
  .inset-phone {
    display: flex;
    flex-direction: column;
    .phone-content {
      overflow-y: auto;
      @include scrollbar(0px);
      .date {
        @include flex-start;
        margin: 8px 0px;
        .row {
          width: 50%;
          margin: 0;
        }
      }
      .peer {
        margin: 8px 0px;
        font-size: $fs-small-l;
        background: $bg-white;
        .peer-row {
          @include flex-start;
          border-bottom: 1px solid $bg-Gainsboro;
          .row {
            width: 50%;
            .peer-phone-content {
              @include flex-start;
              .el-radio {
                margin-right: 10px;
              }
            }
          }
          .peer-text {
            width: 100%;
            height: 32px;
            line-height: 32px;
            @include flex-center;
            color: $color-PhoneCost;
          }
          &:nth-child(4) {
            border-bottom: none;
          }
        }
      }
      
      
      .component-container {
        margin: 8px 0px;
        position: relative;
      }
      .component-container-active {
        border: 1px solid $bg-FormMune;
      }
      .text-container {
        height: 70px;
        font-size: $fs-small-l;
        padding: 0px 10px;
        background: $bg-white;
        @include flex-column-start;
        justify-content: center;
        .sub-title {
          color: $color-PhoneTitle;
          margin-bottom: 11px;
          @include flex-start;
          .star {
            margin-left: 2px;
            color: $color-PhoneStar;
          }
        }
        .phone-content {
          width: 100%;
          color: $color-LightGrey;
          @include flex-between;
        }
      }
      .cost-details {
        width: 100%;
        margin-top: 12px;
        @include flex-center;
        color: $color-PhoneCost;
      }
      .active {
        height: 85px;
        .phone-content {
          margin-bottom: 15px;
        }
      }
      .date-range {
        .add-row {
          @include flex-start;
          .text-container {
            width: 50%;
          }
          &:nth-child(1) {
            @include border-bottom-right(97%, 1px, $bg-Gainsboro);
          }
        }
        .text-container {
          margin: 0px;
        }
      }
      .total {
        padding-left: 10px;
        background: $bg-white;
        .text-container {
          height: 34px;
          margin: 0px;
          padding-left: 0px;
          .sub-title {
            margin-bottom: 0px;
          }
        }
      }
      .upload-invoice {
        padding-bottom: 10px;
        .el-icon-plus {
          width: 48px;
          height: 48px;
          background: $bg-Phone;
          @include flex-center;
        }
      }
      .cost-details-component {
        .text-container {
          .sub-title {
            margin-bottom: 0px;
          }
        }
      }
      .container-component {
        .row {
          font-size: $fs-small-l;
          padding: 12px 0px;
          background: $bg-white;
          @include flex-column-start;
          justify-content: center;
          .text,
          .date-range,
          .upload-component,
          .cost-details-component {
            margin: 0px;
          }
          .sub-title {
            padding: 0px 10px;
            color: $color-PhoneTitle;
            margin-bottom: 11px;
            @include flex-start;
            .star {
              margin-left: 2px;
              color: $color-PhoneStar;
            }
          }
          .nothing-container {
            width: 100%;
            height: 100%;
            height: 48px;
            line-height: 48px;
            text-align: center;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-ContainerComponent;
            background: $bg-Phone;
          }
          .container-content {
            width: 100%;
            background: $bg-Phone;
          }
          .text-container {
            .sub-title {
              padding: 0;
            }
          }
        }
      }
    }
  }
  .nothing {
    position: absolute;
    left: 60%;
    top: 50%;
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
}
</style>
